import React from 'react'
import { Cyber } from '@root/components/Cyber/Cyber'
import { Tabs } from '@root/components/Cyber/types'
import { Payee } from '@root/api/ump-catalog-manager'
import { fetchPayees } from '@root/utils/fetchPayees'

export async function getStaticProps() {
  try {
    const { servicesForSearch } = await fetchPayees()

    const displayedServices = servicesForSearch.reduce((acc, service) => {
      service?.features?.category_web?.split(', ').forEach((category) => {
        if (Object.values(Tabs).includes(category as Tabs)) {
          acc[category] = acc[category] || []
          acc[category].push(service)
        }
      })

      return acc
    }, {}) as Record<Tabs, Payee[]>

    return {
      props: {
        tabsServices: displayedServices,
        servicesForSearch,
      },
      revalidate: 300,
    }
  } catch (error) {
    console.error('Error fetching data:', error)

    return {
      // props: {
      //   tabsServices: [],
      //   servicesForSearch: [],
      // },
      notFound: false,
      revalidate: 60,
    }
  }
}

const HomePage = ({ tabsServices }) => <Cyber tabsServices={tabsServices} />

export default HomePage
